import { createFileRoute } from '@tanstack/react-router'

import { useCreateProductGroup } from '@/api/api-mutations'
import { Button } from '@/components/base/button'
import { Drawer } from '@/components/base/drawer'
import { Heading } from '@/components/base/heading'
import { useCreatedToast } from '@/components/base/toast'
import { FormContainer, FormFieldGroup, useAppForm } from '@/components/form/form'
import { RouteModal, RouteModalFormBlocker, useRouteModal } from '@/components/route-modal'
import { useI18n } from '@/i18n/i18n-react'

export const Route = createFileRoute('/_authenticated/_general/product-groups/create')({
	component: RouteComponent
})

function RouteComponent() {
	return (
		<RouteModal prev='..' asDrawer>
			<NewGroupForm />
		</RouteModal>
	)
}

function NewGroupForm() {
	const { L } = useI18n()
	const { handleSuccess } = useRouteModal()
	const createdToast = useCreatedToast()
	const createProductGroup = useCreateProductGroup()
	const form = useAppForm({
		defaultValues: { name: '' },
		onSubmit: async ({ value }) => {
			const result = await createProductGroup({
				body: { name: value.name }
			})
			if (!result.isSuccess) {
				return
			}
			createdToast(L.ProductGroup.CreateSuccessToast({ name: value.name }), {
				to: '/product-groups/$groupUuid',
				params: { groupUuid: result.response.uuid }
			})
			// `handleSuccess` flips the modal's bypass ref before navigating. Navigating directly from
			// `onSubmit` instead would still trip the unsaved-changes blocker, since TanStack Form only
			// marks the form submitted once `onSubmit` resolves.
			handleSuccess()
		}
	})

	return (
		<form.AppForm>
			<RouteModalFormBlocker form={form as any} />
			<Drawer.Header>
				<Drawer.Title asChild>
					<Heading>{L.ProductGroup.CreateTitle()}</Heading>
				</Drawer.Title>
			</Drawer.Header>
			<Drawer.Body className='flex-1 overflow-auto'>
				<FormContainer>
					<FormFieldGroup>
						<form.AppField
							name='name'
							children={field => <field.TextField placeholder={L.Fields.Name()} />}
						/>
					</FormFieldGroup>
				</FormContainer>
			</Drawer.Body>
			<Drawer.Footer>
				<div className='flex items-center justify-end gap-x-2'>
					<Drawer.Close asChild>
						<Button variant='secondary' size='small'>
							{L.General.Cancel()}
						</Button>
					</Drawer.Close>

					<form.SaveButton />
				</div>
			</Drawer.Footer>
		</form.AppForm>
	)
}
